import React, { useEffect, useState } from 'react';
import { TextField, Button, MenuItem, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import CommonDialog from '../CommonDialog/CommonDialog';

const AddPinDialog = ({ open, onClose, onCellSelect, editPinName, isEdit, onPinRename, editPinShapeType }) => {
  const pins = [
    { pin: 'in', path: '/editors/images/toolbox/input-pin.svg' },
    { pin: 'out', path: '/editors/images/toolbox/input-pin.svg' },
    { pin: 'inout', path: '/editors/images/toolbox/input-output-pin.svg' },
  ];
  const [selectedPin, setSelectedPin] = useState('');
  const [pinName, setPinName] = useState('');
  const [pinCount, setPinCount] = useState(1);
  const [pinError, setPinError] = useState(false);

  useEffect(() => {
    if (open && isEdit) {
      setPinName(editPinName || ""); 
      setSelectedPin(editPinShapeType);
      const names = (editPinName || "")
        .split(' ')
        .map(name => name.trim())
        .filter(name => name !== '');

      setPinCount(names.length || 1);
      setPinError(names.length > 6);
    }
  }, [open, isEdit, editPinName, editPinShapeType]);

  const handlePinTypeChange = (event) => {
    setPinName('')
    const pinValue = event.target.value;
    setSelectedPin(pinValue);
    const names = pinName
      .split(' ')
      .map(name => name.trim())
      .filter(name => name !== '');

    if (names.length > 0 && names.length <= 6) {
      const selected = pins.find(s => s.pin === pinValue);
      if (selected) {
        onCellSelect({
          shapeType: selected.pin,
          imagePath: selected.path,
          labels: [],
        });
      }
    } else {
      onCellSelect(null);
    }
  };

  const handlePinCountChange = (event) => {
    const pinValue = Number(event.target.value);

    if (isNaN(pinValue) || pinValue < 1) {
      setPinCount('');
      setPinError(true);
      return;
    }

    if (pinValue > 6) {
      setPinError(true);
    } else {
      setPinError(false);
      setPinCount(pinValue);
    }
  };

  const handlePinNameChange = (e) => {
    const value = e.target.value;
    setPinName(value);

    const names = value
      .split(' ')
      .map(name => name.trim())
      .filter(name => name !== '');

    setPinCount(names.length);
    setPinError(names.length > 6);

    if (selectedPin && names.length > 0 && names.length <= 6) {
      // Select cell when there are valid names
      const selected = pins.find(s => s.pin === selectedPin);
      if (selected) {
        onCellSelect({
          shapeType: selected.pin,
          imagePath: selected.path,
          labels: names, // array of all names
        });
      }
      
    } else {
      // Clear selection when pin name is empty or no pin type selected
      onCellSelect(null);
    }
  };

  const handlePinRenameInput = (e) => {
    const valueWithoutSpaces = e.target.value.replace(/\s/g, '');
    setPinName(valueWithoutSpaces);
    onPinRename(valueWithoutSpaces);
  };

  const handleCancel = () => {
    setSelectedPin('');
    setPinCount(1);
    setPinName('');
    onClose();
  };

  const handleReset = () => {
    setSelectedPin('');
    setPinCount(1);
    setPinName('');
    onCellSelect(null);
  };

  return (
    <CommonDialog 
      open={open} onClose={handleCancel} title={isEdit ? 'Edit Pin' : 'Add Pin'} hideBackDrop={true}>
      <>

        <Box display="flex" gap={2}>
          <TextField
            select
            label="Type"
            value={selectedPin}
            onChange={handlePinTypeChange}
            fullWidth
            sx={{ flex: 1 }}
            margin="normal"
            disabled={isEdit}
          >
            {pins.map(({ pin }) => (
              <MenuItem key={pin} value={pin}>
                {pin}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            label="# of Pins"
            type="number"
            value={pinCount}
            onChange={handlePinCountChange}
            inputProps={{ min: 1, max: 6 }}
            error={pinError}
            helperText={pinError ? "Please select between 1 and 6 pins." : ""}
            fullWidth
            sx={{ flex: 1 }}
            margin="normal"
            disabled={isEdit}
          />
        </Box>
        
        <TextField
          fullWidth
          margin="normal"
          label="Pin Names"
          value={pinName}
          onChange={isEdit ? handlePinRenameInput : handlePinNameChange}
          inputProps={{ maxLength: 100 }}
        />

      </>
      <>
        <Button variant="contained" className ="customButtonStyle" onClick={handleReset}>Reset</Button>
        <Button variant="contained" className ="customButtonStyle" onClick={handleCancel}>Hide</Button>
      </>
    </CommonDialog>
  );
};

export default AddPinDialog;